import React from 'react';
import { motion } from 'framer-motion';
import { trackPixelEvent } from '../analytics/fbpixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
  fullWidth?: boolean;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  href,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-full transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-wine-700 hover:bg-wine-800 text-white shadow-lg hover:shadow-glow focus:ring-wine-700',
    secondary: 'bg-cream-200 hover:bg-cream-300 text-wine-900 shadow-sm focus:ring-cream-500',
    outline: 'border-2 border-wine-300 hover:border-wine-400 text-wine-800 hover:bg-wine-50 focus:ring-wine-700'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const handleClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (href && href.startsWith('#')) {
      e.preventDefault();
      if (href === '#precio') {
        trackPixelEvent('InitiateCheckout');
      }
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (props.onClick) {
      props.onClick(e as any);
    }
  };
  if (href) {
    return <motion.a href={href} onClick={handleClick} className={classes} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-311">
        {children}
      </motion.a>;
  }
  return <motion.button className={classes} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} {...props} data-id="element-312">
      {children}
    </motion.button>;
}